module.exports = __webpack_public_path__ + "img/tipo-di-progetto-emt.6a613cd0.png";